import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter, FilterFrame, FilterSelection } from '../Filters.style';
import { FilterOption, FilterResultCounts, RangeResultsCounts } from '../../../types';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import FilterExposedHeader from '../FilterExposedHeader';
import { ExteriorListWrapper, OptionWrapper, Image, Label } from './ExteriorSelector.style';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

interface ExteriorSelectorTypes {
  filterType: string;
  exteriorColorOptions: AvailableFiltersCount[];
  confirmedFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const ExteriorSelector: React.FC<ExteriorSelectorTypes> = ({
  filterType,
  exteriorColorOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const { t } = useTranslation();

  const selectedExteriorColors = confirmedFilters.exteriorColor;

  const handleAddExteriorFilter = (newExteriorColor: string) => {
    handleAddFilter('exteriorColor', newExteriorColor);
  };

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedExteriorColors}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props} data-testid="exterior-filter-group">
              <FilterFrame style={filtersAccordianAnimation}>
                <ExteriorListWrapper>
                  {exteriorColorOptions.map((filterOption) => {
                    const { value, image } = filterOption;
                    const label = t(`vlp.filters.filterOptions.${filterType}.${value}`);
                    const isSelected = selectedExteriorColors.includes(value);
                    return (
                      <OptionWrapper
                        key={`ext-${value}`}
                        type="button"
                        onClick={() => handleAddExteriorFilter(value)}
                        isSelected={isSelected}
                        data-testid={`exterior-select-${value}`}
                      >
                        <Image
                          src={image as string}
                          aria-label={`${value} exterior color`}
                          alt={`${value} exterior color`}
                        />
                        <Label>{label}</Label>
                      </OptionWrapper>
                    );
                  })}
                </ExteriorListWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default ExteriorSelector;
